import Box from "@mui/material/Box";
import type { ResponsiveStyleValue } from "@mui/system";
import { colors } from "@/theme/colors";

/**
 * A flat illustration in a hairline-ruled frame on the page background — the
 * shared look across the mega-menu cards (default size) and the landing
 * section cards via IllustratedCard (larger). Pass one of the
 * `illustrations/*` components as the child.
 */
export function IllustrationVisual({
  children,
  height = 116,
  width = 168,
  mb = 2,
}: {
  children: React.ReactNode;
  height?: ResponsiveStyleValue<number>;
  width?: ResponsiveStyleValue<number>;
  mb?: number;
}) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height,
        border: "1px solid",
        borderColor: "divider",
        backgroundColor: colors.background,
        mb,
      }}
    >
      <Box sx={{ width }}>{children}</Box>
    </Box>
  );
}
